import { useNavigate } from "react-router-dom";
import UserInfo from "../../../../../Form/UserInfo";
import { CaloriesResult } from "../../CalculateCalories";
import BlockFooter from "../BlockFooter/BlockFooter";
import BlockHeader from "../BlockHeader/BlockHeader";
import "./BlockResult.css";
import BlockResultLink from "./BlockResultLink";

function BlockResult(props: {
  caloriesResult: CaloriesResult;
  header?: string;
  paragraph?: string;
  footer?: string;
  userDetails: UserInfo;
}) {
  const age: number | undefined = props.userDetails.age;
  let ageGroup: string;
  if (age) {
    if (age < 2) {
      ageGroup = "0-1";
    } else if (age < 4) {
      ageGroup = "2-3";
    } else if (age < 9) {
      ageGroup = "4-8";
    } else if (age < 14) {
      ageGroup = "9-13";
    } else {
      ageGroup = "14-99";
    }
  }

  const navigate = useNavigate();

  function redirectOverall(): void {
    navigate(`/results/${ageGroup}/${props.userDetails.finalCalories.overall}`);
  }

  function redirectToMaintain(): void {
    navigate(
      `/results/${ageGroup}/${props.userDetails.finalCalories.maintain}`
    );
  }

  function redirectToAchieve(): void {
    navigate(
      `/results/${ageGroup}/${props.userDetails.finalCalories.achieveHealthy}`
    );
  }

  function redirectToFirstTrimester(): void {
    navigate(
      `/results/${ageGroup}/${props.userDetails.finalCalories.trimester1}`
    );
  }

  function redirectToSecondTrimester(): void {
    navigate(
      `/results/${ageGroup}/${props.userDetails.finalCalories.trimester2}`
    );
  }

  function redirectToThirdTrimester(): void {
    navigate(
      `/results/${ageGroup}/${props.userDetails.finalCalories.trimester3}`
    );
  }

  return (
    <div className="block-result-section df fdc aic jcse">
      <BlockHeader heading={props.header} paragraph={props.paragraph} />
      <div className="block-result-links-div df aic jcse">
        {props.caloriesResult.trimester1 &&
          props.caloriesResult.actualTrimester &&
          props.caloriesResult.actualTrimester <= 1 && (
            <BlockResultLink
              type="maintain"
              header="პირველი ტრიმესტრის განმავლობაში"
              calories={props.caloriesResult.trimester1}
              onClick={redirectToFirstTrimester}
            />
          )}
        {props.caloriesResult.trimester2 &&
          props.caloriesResult.actualTrimester &&
          props.caloriesResult.actualTrimester <= 2 && (
            <BlockResultLink
              type="maintain"
              header="მეორე ტრიმესტრის განმავლობაში"
              calories={props.caloriesResult.trimester2}
              onClick={redirectToSecondTrimester}
            />
          )}
        {props.caloriesResult.trimester3 &&
          props.caloriesResult.actualTrimester &&
          props.caloriesResult.actualTrimester <= 3 && (
            <BlockResultLink
              type="maintain"
              header="მესამე ტრიმესტრის განმავლობაში"
              calories={props.caloriesResult.trimester3}
              onClick={redirectToThirdTrimester}
            />
          )}
        {props.caloriesResult.maintain && (
          <BlockResultLink
            type="maintain"
            header="არსებული წონის შესანარჩუნებლად"
            calories={props.caloriesResult.maintain}
            onClick={redirectToMaintain}
          />
        )}
        {props.caloriesResult.achieveHealthy && (
          <BlockResultLink
            type="achieve"
            header="ჯანსაღი წონის მისაღწევად"
            calories={props.caloriesResult.achieveHealthy}
            onClick={redirectToAchieve}
          />
        )}
        {props.caloriesResult.overall && (
          <BlockResultLink
            type="overall"
            // header='არსებული წონის შესანარჩუნებლად'
            calories={props.caloriesResult.overall}
            onClick={redirectOverall}
          />
        )}
      </div>
      <BlockFooter paragraph="დეტალური ინფორმაციისთვის დააკლიკეთ შესაბამის კალორიულ გეგმას" />
    </div>
  );
}

export default BlockResult;
